import Vue from 'vue'
import App from './App.vue'
import router from './router'
import langInfo from './i18n/index'
import i18nZh from './i18n/lang/zh'
import i18nEn from './i18n/lang/en'
import './style/index.less'

const { i18n, locale } = langInfo

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = locale === 'zh' ? i18nZh[to.meta.title] : i18nEn[to.meta.title]
  }
  next()
})

Vue.mixin({
  methods: {
    toHmt(type, url) {
      if (_hmt) {
        try {
          _hmt.push([
            "_trackEvent",
            "success",
            type
          ]);
        } catch (e) {
          console.log(e);
        }
      }
      window.location = url
    }
  }
})

new Vue({
  i18n,
  router,
  render: h => h(App)
}).$mount('#app')
